import request from '../request/request';
import {handleRes} from '../utils/utils';


interface HandleResInterface {
  success: any,
  fail: any,
}


const getMchList = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request.GETMchReportProperty(params);
    const result = handleRes(res, {
      failMes: res.msg
    });
    resolve(result);
  });
};

const getParkingList = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request.GETParkingReport(params);
    const result = handleRes(res, {
      failMes: res.msg
    });
    resolve(result);
  });
};



export {
  getMchList,
  getParkingList
};
